export default {
	"entry": {
		"mainOrderAndInfo": "แบบฟอร์มคำสั่งการขนส่งพร้อมรายละเอียดสินค้า",
		"downloadMainOrderAndInfo": "ดาวน์โหลดตัวอย่างแบบฟอร์มคำสั่งการขนส่งพร้อมรายละเอียดสินค้า",
		"mainOrderNoInfo": "แบบฟอร์มคำสั่งการขนส่ง",
		"downloadMainOrderNoInfo": "ดาวน์โหลดตัวอย่างแบบฟอร์มคำสั่งการขนส่ง",
		"orderImportSuccess": "นำเข้าคำสั่งขนส่งสำเร็จ",
		"void": "ลบ",
		"inputOrderTips": "กรุณากรอกหมายเลขคำสั่งขนส่ง",
		"orderStatus": "สถานะของคำสั่ง",
		"element": "บาท",
		"confirmOperationErrorPrompt": "ยืนยันข้อความแจ้งความผิดพลาดในการดำเนินการ",
		"batchModifiy": "แก้ไขแบบกลุ่ม",
		"modifiyTips": "กรอกข้อมูลในช่องที่ต้องแก้ไขร่วมกัน ส่วนช่องอื่นๆ ให้เว้นว่าง",
		"dispatchErrorTips": "ไม่สามารถดำเนินการจัดตารางรถได้ เนื่องจากสถานะของรายการเป็น order_confirmed",
		"dispatchSuccessTips": "ส่งสำเร็จ",
		"currentDataNotUse": "สถานะข้อมูลปัจจุบันไม่สามารถใช้งานได้",
		"reviewed": "ยืนยันแล้ว",
		"checkDataTips": "กรุณาตรวจสอบข้อมูลที่มีสถานะ [ยืนยันแล้ว]!",
		"voidTips": "ท่านต้องการลบใบสั่งขนส่งสินค้าที่ถูกเลือกหรือไม่",
		"importOrder": "นำเข้าใบคำสั่งขนส่งสินค้า",
		"otherInfo": "ข้อมูลอื่นๆ",
		"custom": "ปรับแต่ง",
		"editingPageTips": "หน้าแก้ไขรายละเอียดคำสั่งขนส่ง",
		"orderDetaile": "รายละเอียดปริมาณสินค้าของการสั่งซื้อ",
		"attachmentTips": "เอกสารแนบมากับคำสั่ง"
	},
	"entryCreate": {
		"againOrder": "คัดลอกคำสั่งใหม่",
		"directDispatch": "จัดตารางรถ",
		"shipperTips": "กรุณาเลือกชื่อผู้ส่งสินค้า",
		"partnerNameTips": "กรุณาเลือกกลุ่มค่าธรรมเนียม/ส่วนลด",
		"orderQuantity": "ปริมาณการสั่งซื้อ",
		"doubleClickRestore": "คลิ๊กสองครั้งเพื่อเรียกคืนมูลค่าการสั่งซื้อ",
		"temperatureControlNameTips": "กรุณาเลือกประเภทอุณหภูมิ",
		"customerSAPCodeTips": "กรุณากรอกรหัส SAP ลูกค้า",
		"remarkTips": "สามารถกรอกได้มากสุด 250 ตัวอักษร",
		"volumeTips": "กรุณากรอกปริมาณ (ต้องกรอก)",
		"packingQtyTips": "กรุณาระบุจำนวนบรรจุภัณฑ์ (ต้องกรอก)",
		"weightTips": "กรุณากรอกน้ำหนัก (ต้องกรอก)",
		"goodsQtyTips": "กรุณาระบุจำนวนสินค้า",
		"goodsValueTips": "กรุณากรอกมูลค่าประกันสินค้า",
		"goodsTypeTips": "กรุณาระบุประเภทสินค้า",
		"requirement": "ต้องมี",
		"origin": "ต้นทาง",
		"destination": "ปลายทาง",
		"deliverGoods": "ส่ง",
		"pleaseSelect": "กรุณาเลือก",
		"pleaseEnter" :"กรุณากรอก",
		"receivingGoods": "รับสินค้า",
		"pleaseSelectDate": "กรุณาเลือกเวลา",
		"pleaseSelectProvinceAndCityAndDistrict": "กรุณากรอกจังหวัด เมือง เเละอำเภอ",
		"addressTips": "กรุณาเลือกที่อยู่",
		"pickupCommentsTips": "กรุณากรอกรายละเอียดสินค้า",
		"carrierProductNotEmpty": "ไม่สามารถเว้นว่าง กลุ่มค่าธรรมเนียม/ส่วนลด",
		"latestReceivedDtTips": "เวลาจัดส่งล่าสุดต้องไม่ช้ากว่าเวลารับสินค้าล่าสุด!",
		"latestDeliveryDtTips": "เวลารับสินค้าล่าสุดต้องไม่เร็วกว่าเวลาจัดส่งล่าสุด!",
		"cloneOrderTips": "สำหรับข้อมูลคำสั่งการขนส่งที่คัดลอกสำเร็จ กรุณาปรับค่าพารามิเตอร์คำสั่งขนส่งตามสถานการณ์เฉพาะเจาะจง",
		"isInsuranceTips": "เมื่อตรวจสอบผู้เอาประกันภัยแล้ว ใบแจ้งยอดต้องมากกว่า 0",
		"dispatchFailedTips": "กำหนดการโดยตรงไม่สำเร็จ",
		"vehicleTypeTips": "กรุณาเลือกรุ่นรถ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/order/order.js